import { render, staticRenderFns } from "./SelectRestrictionFormElement.vue?vue&type=template&id=6a8320e5&scoped=true&"
import script from "./SelectRestrictionFormElement.vue?vue&type=script&lang=js&"
export * from "./SelectRestrictionFormElement.vue?vue&type=script&lang=js&"
import style0 from "./SelectRestrictionFormElement.vue?vue&type=style&index=0&id=6a8320e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8320e5",
  null
  
)

export default component.exports